import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardAthletsEdit = guard(groupRights.Sportsmen)('edit')
export const guardAthletsWatch = guard(groupRights.Sportsmen)('watch')
export const guardAthletsCreate = guard(groupRights.Sportsmen)('create')

